import script from "./new_comments_sidebar.vue?vue&type=script&setup=true&lang=js"
export * from "./new_comments_sidebar.vue?vue&type=script&setup=true&lang=js"

import "./new_comments_sidebar.vue?vue&type=style&index=0&id=68ebe3bc&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-68ebe3bc"]])

export default __exports__